import {NgModule, StaticProvider} from '@angular/core';
import {BrowserModule} from "@angular/platform-browser";
import {platformBrowserDynamic} from "@angular/platform-browser-dynamic";
import {downgradeModule} from "@angular/upgrade/static";
import {CommonsModule} from "../../commons/angular/commons.module";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {TranslateModule} from "@ngx-translate/core";
import {NgxPermissionsModule} from "ngx-permissions";
import {ScrollingModule} from "@angular/cdk/scrolling";
import { ScrollingModule as ScrollingModuleExperimental } from '@angular/cdk-experimental/scrolling';
import {
  PlanningRoutesTableRowComponent
} from "./components/planning-routes-table-row/planning-routes-table-row.component";
import {RouteActionMenuComponent} from "./components/route-action-menu/route-action-menu.component";
import {PlanningRoutesTableComponent} from "./components/planning-routes-table/planning-routes-table.component";
import {
  RouteAssistantAssignmentComponent
} from "./components/route-assistant-assignment/route-assistant-assignment.component";
import {AgentsModule} from "../../agents/angular/agents.module";


@NgModule({
  declarations: [
    PlanningRoutesTableRowComponent,
    RouteActionMenuComponent,
    PlanningRoutesTableComponent,
    RouteAssistantAssignmentComponent
  ],
    imports: [
        BrowserModule,
        CommonsModule,
        NgbModule,
        ScrollingModule,
        ScrollingModuleExperimental,
        TranslateModule.forChild(),
        NgxPermissionsModule.forChild(),
        AgentsModule
    ],
  providers: [],
  exports: []
})

export class LeanPlanningModule {
  constructor() {
  }

  ngDoBootstrap() {
  }
}

const bootstrapLeanPlanningModule = (extraProviders: StaticProvider[]) => {
  const platformRef = platformBrowserDynamic(extraProviders);
  return platformRef.bootstrapModule(LeanPlanningModule);
};

export const downgradedLeanPlanningModule = downgradeModule(bootstrapLeanPlanningModule);
